export const fallbackLng = 'en'
export const languages = [fallbackLng, 'fr']
export const defaultNS = 'default'

export const languageFromLocaleStr = (localeStr: string) =>
  localeStr.split('-')[0] ?? fallbackLng

export function getOptions(lng = fallbackLng, ns = defaultNS) {
  return {
    // debug: true,
    supportedLngs: languages,
    fallbackLng,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns,
  }
}
